import useMemoryGame from './useMemoryGame.hook';
import { StyledMemoryGame } from './MemoryGame.styled';
import { GameStageContextProvider } from '@/shared/GameComponents/GameStageContext/GameStageContext';
import {
  GameAssetsContext,
  GameAssetsContextProvider,
} from '@/shared/GameComponents/GameAssetsContext/GameAssetsContext';
import {
  GameLoopContext,
  GameLoopContextProvider,
} from '@/shared/GameComponents/GameLoopContext/GameLoopContext';
import MemoryGameLoop from './MemoryGameLoop/MemoryGameLoop';
import Chronometer from '../../Chronometer/Chronometer';

export default function MemoryGame({
  gameAssetsFolder,
  commonAssetsFolder,
  activityData,
  activityConf,
  onCorrectAnswer,
  onFinishedActivity,
  language,
}) {
  const { actions } = useMemoryGame({
    gameAssetsFolder,
    commonAssetsFolder,
    activityData,
    activityConf,
    language,
  });
  return (
    <StyledMemoryGame>
      <GameStageContextProvider scaleAxis={'x'}>
        <GameAssetsContextProvider
          gameAssetsFolder={gameAssetsFolder}
          gameData={activityData}
          prepareAssets={actions.prepareAssets}
        >
          <GameLoopContextProvider
            fps="30"
            gameConf={activityData.gameConf}
            prepareGameData={actions.prepareGameData}
            initialState={{
              gameConf: null, // Original data json on db
              flippedCards: [],
              answersLog: [],
              matchedConcepts: [],
              playingCardAudio: false,
              givingFeedback: false, // for a particular answer
              feedbackFinished: false, // for a particular answer
              cards: [],
              elapsedTime: {
                minutes: 0,
                seconds: 0,
              },
            }}
          >
            <GameAssetsContext.Consumer>
              {(assets) => (
                <GameLoopContext.Consumer>
                  {(game) =>
                    game.state.isReady && (
                      <div>
                        <Chronometer
                          tick={assets.state.sounds['clock-tick']}
                          alarm={assets.state.sounds['clock-alarm']}
                        />
                        <MemoryGameLoop
                          gameAssetsFolder={gameAssetsFolder}
                          gameData={activityData.gameData}
                          onCorrectAnswer={onCorrectAnswer}
                          onFinish={onFinishedActivity}
                        />
                      </div>
                    )
                  }
                </GameLoopContext.Consumer>
              )}
            </GameAssetsContext.Consumer>
          </GameLoopContextProvider>
        </GameAssetsContextProvider>
      </GameStageContextProvider>
    </StyledMemoryGame>
  );
}
